import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { USER_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

export const fetchCompanyDetails = async (
  companyId: string
): Promise<{
  status: 'error' | 'ok'
  data: any
  error: string | undefined
}> => {
  try {
    const url = `${USER_SERVICE_BASE_URL}/companies/${companyId}`
    const response = await axios.get(url)
    return extract.data(response)
  } catch (error) {
    throw new Error(error)
  }
}

export const useCompanyDetails = (
  companyId: string,
  options?: Pick<UseQueryOptions, 'retry'>
) => {
  return useQuery({
    queryKey: [`/companies/${companyId}`],
    queryFn: async () => {
      const { data } = await fetchCompanyDetails(companyId)
      return data
    },
    enabled: !!companyId,
    ...options,
  })
}
